import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util';
import router from '@/router';
import {ActionContext} from 'vuex';
import store from "@/store";
import request from '@/util/request';

export default {
  namespaced: true,
  mutations:{
    commonLog(){

    }
  },
  actions: {
    /**
     * @description 登录
     * @param {Object} param context
     * @param {Object} param username {String} 用户账号
     * @param {Object} param password {String} 密码
     * @param {Object} param route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({ dispatch }: ActionContext<any, any>, {
      unionId = '', accessToken = '', nickname = '', headImageUrl = '',
      roleNum = -1, puid = '', name = '', uuid = '',
    } = {}) {
      return new Promise(async (resolve, reject) => {
        // 设置 cookie 一定要存 uuid 和 token 两个 cookie
        // 整个系统依赖这两个数据进行校验和存储
        // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
        // token 代表用户当前登录状态 建议在网络请求中携带 token
        // 持续登录：登录状态保留 30 天，后端会在使用时滑动续期
        util.cookies.set('uuid', unionId, {expires: 30});
        util.cookies.set('token', accessToken, {expires: 30});
        // 设置 vuex 用户信息
        await dispatch('d2admin/user/set', {
          name, nickname, roleNum, puid, headImageUrl, uuid,
        }, { root: true });
        // 用户实际登录的时候可以刷新菜单
        // 用户登录后从持久化数据加载一系列的设置
        await dispatch('load');
        // 结束
        resolve();
      });
    },
    thirdLogin({dispatch}, {unionId='', uuid='', token='', name='', nickname='', puid='',roleNum = -1}) {

      return new Promise(async (resolve) => {
        util.cookies.set('uuid', uuid, {expires: 30});
        util.cookies.set('token', token, {expires: 30});

        await dispatch('d2admin/user/set', {
          name, nickname, roleNum, puid, uuid,
        }, { root: true });
        // localStorage.setItem('user', JSON.stringify(data));
        await dispatch('load');
        // 结束
        resolve();
      });

    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} param context
     * @param {Object} param confirm {Boolean} 是否需要确认
     */
    logout({ commit, dispatch }: ActionContext<any, any>, { confirm = false } = {}) {
      /**
       * @description 注销
       */
      async function logout() {
        try {
          await request.post('/api/logout');
        } catch (error) {
          // 即使服务端不可用，也继续清理本地登录状态
        }
        // 删除cookie
        util.cookies.remove('token');
        util.cookies.remove('uuid');
        // 清空 vuex 用户信息
        await dispatch('d2admin/user/set', {}, { root: true });
        // 跳转路由
        router.push({
          name: 'login',
        });
      }
      // 判断是否需要确认
      if (confirm) {
        commit('d2admin/gray/set', true, { root: true });
        MessageBox.confirm('注销当前账户吗?  打开的标签页和用户设置将会被保存。', '确认操作', {
          confirmButtonText: '确定注销',
          cancelButtonText: '放弃',
          type: 'warning',
        })
          .then(() => {
            store.commit('vendors/clearList',{});
            store.commit('clearAllSearchInfo',{});
            commit('d2admin/gray/set', false, { root: true });
            logout();
          })
          .catch(() => {
            commit('d2admin/gray/set', false, { root: true });
            Message({
              message: '放弃注销用户',
            });
          });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} state vuex state
     */
    load({ dispatch }: ActionContext<any, any>) {
      return new Promise(async (resolve) => {
        // DB -> store 加载用户名
        await dispatch('d2admin/user/load', null, { root: true });
        // DB -> store 加载主题
        await dispatch('d2admin/theme/load', null, { root: true });
        // DB -> store 加载页面过渡效果设置
        await dispatch('d2admin/transition/load', null, { root: true });
        // DB -> store 持久化数据加载上次退出时的多页列表
        await dispatch('d2admin/page/openedLoad', null, { root: true });
        // DB -> store 持久化数据加载侧边栏折叠状态
        await dispatch('d2admin/menu/asideCollapseLoad', null, { root: true });
        // DB -> store 持久化数据加载全局尺寸
        await dispatch('d2admin/size/load', null, { root: true });
        // end
        resolve();
      });
    },
  },
};
